<template>
  <div id="app">
    <TheHeader />
    <transition :name="transitionName" mode="out-in">
      <router-view :key="$route.path" />
    </transition>
    <cursor-fx color="#BD9560" transition-duration=".5s" inside-size="12rem" outside-size="12rem" mix-blend-mode="difference" data-slot="Lire" />
  </div>
</template>
<script>
import Vue from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'

Vue.directive('observe-visibility', ObserveVisibility)

import articlesJSON from '@/content.js';

import { CursorFx } from '@luxdamore/vue-cursor-fx';
import '@luxdamore/vue-cursor-fx/dist/CursorFx.css';

/*import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);*/

import TheHeader from "@/components/TheHeader"

const DEFAULT_TRANSITION = 'slide-fade';

export default {
  components: {
    TheHeader,
    'cursor-fx': CursorFx,
  },
  data(){
    return {
      myArticles: articlesJSON.articles,
      transitionName: DEFAULT_TRANSITION
    }
  },
  methods: {
    /*UpdateLax() {
      this.$lax.update(window.scrollY);
      window.requestAnimationFrame(this.UpdateLax);
    },*/
    setBackground($layout = 'dark'){
      document.querySelector('body').className = $layout;
    }
  },
  mounted() {

    document.getElementById('app').scrollIntoView();
    //window.requestAnimationFrame(this.UpdateLax);
    //this.setBackground('dark');

    
  },
  created() {

    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length;
        const fromDepth = from.path.split('/').length;
        transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();


      console.log(to.meta.transitionName);
    });

    //this.$lax.setup();

    // Useful for shared methods, like setBackground
    window.componentInstance = this;
  }
};
</script>

<style lang="scss">
.cursor-fx{
    z-index: 10000000;
}

.splash{
  /*position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #2c3e50;
  z-index: 98;*/
}

.slide-fade-enter-active {
  transition: opacity .3s ease;
}
.slide-fade-leave-active {
  transition: opacity .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  //transform: scale(1.2,1.2);
  opacity: 0;
  //filter: blur(4px);
}

/*.publication--header{
  transition: all 1s ease-in-out 0.5s;
}
.publication--background{
  transition: all 0.5s ease-in-out;
}

.slide-enter-to,
.slide-leave{

  .publication--header{
    opacity: 1;
    transform: translate3d(0,0,0);
  }

  .publication--background{
    opacity: 1;
    filter: blur(0);
    transform: scale(1,1);
  }

}

.slide-enter,
.slide-leave-to {

  .publication--header{
    opacity: 0;
    transform: translate3d(0,-40px,0);
  }
  .publication--background{
    opacity: 0;
    filter: blur(4px);
    transform: scale(1.1,1.1);
  }
}*/
</style>
